import React from 'react'
import { Modal } from "react-bootstrap"

export default function LoadingUpdates({loading, title, openLoading}) {
    return (
        <Modal
            size="sm"
            show={openLoading}
            aria-labelledby="example-modal-sizes-title-sm"
            style={{ borderRadius: 30 }}
        >
            <Modal.Body style={{ display: 'flex', gap: 10, justifyContent: 'start', alignItems: 'center' }}>
                <img style={{ width: 40 }} src='https://rethinkarchive.rippel.org/wp-content/themes/rethink-for-health-theme/images/spinner.gif' />
                <p style={{ marginBottom: '-.15em',fontWeight:'bold' }}>{title ?? "ກຳລັງອັບເດດ..."}</p>
            </Modal.Body>
        </Modal>
    )
}
